import React from 'react';
import { DayOfWeek } from '@core/generated/gql-types';
import {
  getDayOfWeekMinimalLabel,
  getDayOfWeekShortLabel,
} from '@core/job/workingDays/workingDays.util';

interface WorkingDaysSelectorProps {
  /** Days shown in the picker, in week order. Every day here is selectable. */
  selectableDays: DayOfWeek[];
  selectedDays: DayOfWeek[];
  onToggleDay: (day: DayOfWeek) => void;
}

const WorkingDaysSelector: React.FC<WorkingDaysSelectorProps> = ({
  selectableDays,
  selectedDays,
  onToggleDay,
}) => {
  const getDayTitle = (day: DayOfWeek) => {
    if (selectedDays.length === 1 && selectedDays[0] === day) {
      return 'A job must run on at least one day';
    }
    return getDayOfWeekShortLabel(day);
  };

  return (
    <div>
      <label className="mb-1 block text-sm font-medium">Working days</label>
      <div className="flex flex-wrap gap-2">
        {selectableDays.map((day) => {
          const isSelected = selectedDays.includes(day);
          return (
            <button
              key={day}
              type="button"
              aria-pressed={isSelected}
              aria-label={getDayOfWeekShortLabel(day)}
              title={getDayTitle(day)}
              onClick={() => onToggleDay(day)}
              className={`h-10 w-10 rounded-lg border text-sm font-medium ${
                isSelected
                  ? 'border-blue-500 bg-blue-50 text-blue-700 hover:bg-blue-100'
                  : 'border-gray-300 bg-white text-gray-500 hover:bg-gray-50'
              }`}
            >
              {getDayOfWeekMinimalLabel(day)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WorkingDaysSelector;
